import { useEffect } from 'react';
import { Role } from '../types/User';

const useScript = (url: string, loaded: any) => {
  useEffect(() => {
    const script = document.createElement('script');

    script.src = url;
    script.async = true;

    document.body.appendChild(script);
    script.onload = (_ev) => {
      loaded();
    };
    return () => {
      setTimeout(function () {
        document.body.removeChild(script);
      }, 2500);
    };
  }, [loaded, url]);
};
export const convertToSelect = (
  items: Array<any>,
  labelStr: string,
  valueStr: string,
) => {
  const arrayMod: Array<any> = [];
  items.forEach((item: any) => {
    arrayMod.push({
      label: item[labelStr],
      value: item[valueStr],
      year: item[labelStr].split(' ')[1],
      ...item,
    });
  });
  return arrayMod;
};
export const convertRolesToSelect = (
  items: Array<Role>
) => {
  const arrayMod: Array<any> = [];
  items.forEach((item: Role) => {
    if (item.role === 1) {
      arrayMod.push({
        label: "Student",
        value: item.role_id,
        ...item,
      });
    } else if (item.role === 2) {
      arrayMod.push({
        label: "Instructor",
        value: item.role_id,
        ...item,
      });
    } else {
      arrayMod.push({
        label: "Admin",
        value: item.role_id,
        ...item,
      });
    }
  });
  return arrayMod;
};
export default useScript;
